class MacleApiError extends Error {
  fileName: string = '';
  lineNumber: number = 1;
  columnNumber: number = -1;

  constructor(apiName: string, reason: string) {
    const message = `${apiName} fail, ${reason}`;
    super(message);
    this.name = this.constructor.name;
    if (!this.stack) {
      return;
    }
    const [, fileName, lineNumber = 1, columnNumber] =
      this.stack.match(/\/([\/\w-_\.]+\.js):(\d*):(\d*)/) || [];
    this.fileName = fileName;
    this.lineNumber = Number(lineNumber);
    this.columnNumber = Number(columnNumber);
  }
}

class MacleApiErrorno extends MacleApiError {
  errno ?: number;

  constructor(apiName: string, reason: string, errno ?: number) {
    super(apiName, reason);
    this.errno = errno;
    this.name = this.constructor.name;
  }
}

export {MacleApiError, MacleApiErrorno};
